const description = {
    email: 'e-mail',
    phone_number: 'número de telefone',
    username: 'nome de usuário',
    reminder: 'Lembrete',
    not_found: '404 Não Encontrado',
    agree_with_terms: 'Eu li e concordo com os ',
    agree_with_terms_modal: 'Para continuar, por favor, concorde com os <link></link>.',
    terms_of_use: 'Termos de uso',
    sign_in: 'Entrar',
    privacy_policy: 'Política de privacidade',
    create_account: 'Criar conta',
    switch_account: 'Trocar conta',
    or: 'ou',
    and: 'e',
    enter_passcode: 'O código de verificação foi enviado para o seu {{address}} {{target}}',
    passcode_sent: 'O código de verificação foi reenviado',
    resend_after_seconds: 'Ainda não recebeu? Reenviar após <span>{{seconds}}</span> segundos',
    resend_passcode: 'Ainda não recebeu? <a>Reenviar código de verificação</a>',
    create_account_id_exists: 'Uma conta com {{value}} já existe. Continuar a entrar.',
    link_account_id_exists: 'A conta com {{type}} {{value}} já existe, gostaria de vincular?',
    sign_in_id_does_not_exist: 'Nenhuma conta encontrada para {{value}}. Criar uma nova?',
    sign_in_id_does_not_exist_alert: 'A conta com {{type}} {{value}} não existe.',
    create_account_id_exists_alert: 'A conta com {{type}} {{value}} está vinculada a outra conta. Por favor, tente outro {{type}}.',
    social_identity_exist: 'O {{type}} {{value}} está vinculado a outra conta. Por favor, tente outro {{type}}.',
    bind_account_title: 'Vincular ou criar conta',
    social_create_account: 'Você pode criar uma nova conta.',
    social_link_email: 'É possível vincular outro e-mail',
    social_link_phone: 'É possível vincular outro telefone',
    social_link_email_or_phone: 'É possível vincular outro e-mail ou telefone',
    social_bind_with_existing: 'Encontramos uma conta relacionada que já foi registrada, e você pode vinculá-la diretamente.',
    skip_social_linking: 'Pular vinculação à conta existente?',
    reset_password: 'Esqueceu a senha',
    reset_password_description: 'Digite o {{types, list(type: disjunction;)}} à sua conta e enviaremos a você o código de verificação para redefinir sua senha.',
    new_password: 'Nova senha',
    set_password: 'Configurar senha',
    password_changed: 'Senha alterada',
    no_account: 'Ainda não tem conta? ',
    have_account: 'Já tinha uma conta?',
    enter_password: 'Digite a senha',
    enter_password_for: 'Entre com a senha para {{method}} {{value}}',
    enter_username: 'Definir nome de usuário',
    enter_username_description: 'O nome de usuário é uma alternativa para fazer login. O nome de usuário deve conter apenas letras, números e sublinhados.',
    link_email: 'Linkar e-mail',
    link_phone: 'Linkar telefone',
    link_email_or_phone: 'Linkar e-mail ou telefone',
    link_email_description: 'Para maior segurança, vincule seu e-mail à conta.',
    link_phone_description: 'Para maior segurança, vincule seu telefone à conta.',
    link_email_or_phone_description: 'Para maior segurança, vincule seu e-mail ou telefone à conta.',
    continue_with_more_information: 'Para maior segurança, preencha os detalhes da conta abaixo.',
    create_your_account: 'Crie sua conta',
    sign_in_to_your_account: 'Faça login na sua conta',
    device_activation: 'Ativação do dispositivo',
    device_activation_description: 'Insira o código exibido no seu dispositivo. Certifique-se de que corresponde e continue para fazer login neste dispositivo.',
    device_activation_error_description: 'Insira o código exibido no seu dispositivo.',
    device_activation_success: 'Seu dispositivo está conectado!',
    device_activation_success_description: 'Retorne ao seu dispositivo para continuar.',
    no_region_code_found: 'Não foi possível encontrar o código de região do seu telefone.',
    verify_email: 'Verificar e-mail',
    verify_phone: 'Verificar número de telefone',
    password_requirements: 'Senha {{items, list}}.',
    password_requirement: {
        length_one: 'requer no mínimo 1 caractere.',
        length_two: 'requer no mínimo {{count}} caracteres',
        length_few: 'requer no mínimo {{count}} caracteres',
        length_many: 'requer no mínimo {{count}} caracteres',
        length_other: 'requer no mínimo {{count}} caracteres.',
        character_types_one: 'deve conter pelo menos 1 tipo de letra maiúscula, letra minúscula, dígito e símbolo.',
        character_types_two: 'deve conter pelo menos {{count}} tipos de letras maiúsculas, letras minúsculas, dígitos e símbolos',
        character_types_few: 'deve conter pelo menos {{count}} tipos de letras maiúsculas, letras minúsculas, dígitos e símbolos',
        character_types_many: 'deve conter pelo menos {{count}} tipos de letras maiúsculas, letras minúsculas, dígitos e símbolos',
        character_types_other: 'deve conter pelo menos {{count}} tipos de letra maiúscula, letra minúscula, dígito e símbolo.',
    },
    use: 'Usar',
    single_sign_on_email_form: 'Insira o endereço de e-mail corporativo',
    single_sign_on_connectors_list: 'Sua empresa ativou o Single Sign-On para a conta de email {{email}}. Você pode continuar a fazer login com os seguintes provedores de SSO.',
    single_sign_on_enabled: 'Esta conta tem Single Sign-On ativado.',
    authorize_title: 'Autorizar {{name}}',
    request_permission: '{{name}} está solicitando acesso a:',
    grant_organization_access: 'Conceder acesso à organização:',
    authorize_personal_data_usage: 'Autorizar o uso dos seus dados pessoais:',
    authorize_organization_access: 'Autorizar acesso à organização específica:',
    user_scopes: 'Dados pessoais do usuário',
    organization_scopes: 'Acesso à organização',
    authorize_agreement: `Ao autorizar o acesso, você concorda com os <link></link> de {{name}}.`,
    authorize_agreement_with_redirect: `Ao autorizar o acesso, você concorda com os <link></link> de {{name}}, e será redirecionado para {{uri}}.`,
    not_you: 'Você não é?',
    user_id: 'ID do usuário: {{id}}',
    redirect_to: 'Você será redirecionado para {{name}}.',
    auto_agreement: 'Ao continuar, você concorda com os <link></link>.',
    identifier_sign_in_description: 'Digite seu {{types, list(type: disjunction;)}} para entrar.',
    all_sign_in_options: 'Todas as opções de login',
    identifier_register_description: 'Digite seu {{types, list(type: disjunction;)}} para criar uma nova conta.',
    all_account_creation_options: 'Todas as opções de criação de conta',
    back_to_sign_in: 'Voltar para o login',
    support_email: 'E-mail de suporte: <link></link>',
    support_website: 'Site de suporte: <link></link>',
    switch_account_title: 'Você está atualmente conectado como {{account}}',
    switch_account_description: 'Para continuar, você será desconectado da conta atual e automaticamente trocado para a nova conta.',
    about_yourself: 'Conte-nos sobre você',
    verify_identity: 'Verifique sua identidade',
    choose_verification_method: 'Escolha como deseja fazer login',
    verification_method: {
        passkey: 'Chave de acesso',
        passkey_description: 'Verifique via seu dispositivo ou hardware USB',
        password: 'Senha',
        password_description: 'Digite sua senha',
        email_verification_code: 'Código de verificação por e-mail',
        phone_verification_code: 'Código de verificação por telefone',
        verification_code_description: 'Enviar para {{target}}',
    },
};
export default Object.freeze(description);
